// Глобальный кэш события beforeinstallprompt, чтобы не потерять его между роутами
type BIPEvent = any; // у Chrome тип не публичный

let cached: BIPEvent | null = null;

export function setDeferredPrompt(ev: BIPEvent | null) {
  cached = ev;
}

export function getDeferredPrompt(): BIPEvent | null {
  return cached;
}
